import React from "react";
import FunctionsData from "../../Functions/FunctionsData";
import {Button, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup} from "@mui/material";
import jwt from "jsonwebtoken";
import scissors from "../../img/scissors.png";

/*
animals={animals} setAnimals={setAnimals}
						frmOrderID={frmOrderID}
						currentVetArr={currentVetArr}
						aStep={aStep} setAStep={setAStep}
						jwtKey={jwtKey}
						frmFn={frmFn}
						frmLn={frmLn}
						frmEmail={frmEmail}
						ReactGA={ReactGA}
 */
export function Step4Final({animals,setAnimals,frmOrderID, currentVetArr, aStep, setAStep, jwtKey, frmFn, frmLn, frmEmail, ReactGA}) {

    function printVoucher() {

        window.gtag('event', 'action', {
            category: 'User',
            action: 'Clicked Print Voucher Button'
        });

        let arr = [];
        let expiry = new Date().toISOString().slice(0, 10);
        for (let x in animals) {
            const r = animals[x];
            arr.push({
                name: r.name,
                voucher: r.voucher,
                expiry_date: r.expiry_date,
                expiry: r.expiry_date
            });
            if (expiry < r.expiry_date) expiry = r.expiry_date;
        }


        const urlJwt = {
            name: currentVetArr.business_name,
            order_id: frmOrderID,
            email: frmEmail,
            user: frmFn + " " + frmLn,
            vet_id: currentVetArr.id,
            expiry: new Date(expiry)
        };

        let url = 'print/?cid=' + jwt.sign({...urlJwt, vouchers: arr}, jwtKey);
        //console.log(url);
        const newWindow = window.open(url, '_blank',
            'noopener,noreferrer'
        );

        if (newWindow) newWindow.opener = null
    }

    return (
        <div>
            <div className={"thank-you"} style={{textAlign: 'center'}}>
                <h1>
                    Thank you for making a difference.
                </h1>

                <p>
                    We have sent you an email with your Snip'n'Chip voucher(s), and the details of the vet clinic you
                    selected.
                </p>

                <div className={"consent-block"} style={{display: 'flex'}}>
                    <div>
                        <img src={scissors} style={{height: 50, width: 50, marginTop: 0, marginRight: 20}}/>
                    </div>
                    <div>
                        <strong>Next Step:</strong> To arrange your Snip'n'Chip appointment(s), please contact the vet
                        clinic you selected as part of the registration process.
                    </div>
                </div>

                <p>Please note: If you do not receive an email with your voucher(s) within 24hrs, please check your spam
                    folder. If it’s not there, please email <a href={"mailto:snipnchip@spca.nz"}
                                                               target={"_blank"}>snipnchip@spca.nz</a></p>
                <div style={{marginBottom: 20}}>
                    <Button size="full"
                            onClick={printVoucher}
                            sx={{width: '100%'}}
                            variant={"contained"}
                    >
                        Print your voucher now
                    </Button>
                </div>
                <SurveyCheckList frmOrderID={frmOrderID}/>
            </div>
            <Button size="full"
                    onClick={() => {
                        setAnimals([]);
                        setAStep(2)
                    }}
                    sx={{margin: 1}}>
                Get another voucher
            </Button>
            <Button size="full"
                    onClick={() => {
                        window.location.reload();
                    }}
                    sx={{margin: 1}}>
                Close
            </Button>
        </div>
    )
}


const SurveyCheckList = ({frmOrderID}) => {

    const [value, setValue] = React.useState("");
    const options = [
        {slug: "facebook", name: "Facebook"},
        {slug: "local/staff", name: "Local SPCA center or staff"},
        {slug: "family/friends", name: "Family / friends"},
        {slug: "vet", name: "Vet"},
        {slug: "opshop", name: "SPCA Op Shop"},
        {slug: "spca.nz", name: "SPCA website"},
        {slug: "news", name: "Newspaper"},
        {slug: "support_agency", name: "Support agency (e.g. Housing NZ)"},
    ]

    function handleChange(e) {
        setValue(e.target.value);
        FunctionsData.postData(
            '/api/orders/order/' + frmOrderID,
            {"marketing_source": e.target.value}
        )
            .then(r => window.gtag('event', 'action', {
                category: 'User',
                action: 'Filled out survey'
            }))
    }

    if (value !== '') return (
        <div className={"consent-block"}>
            <h3>Thank you for your feedback.</h3>
        </div>
    )

    return (
        <div className={"consent-block"}>
            <FormControl component="fieldset">
                <FormLabel component="legend">How did you hear about this initiative?</FormLabel>
                <RadioGroup
                    aria-label="gender"
                    name="controlled-radio-buttons-group"
                    value={value}
                    onChange={handleChange}
                >
                    {options.map((o,idx) => {
                        return (
                            <FormControlLabel key={idx} value={o.name} control={<Radio/>} label={o.name}/>
                        )
                    })}
                </RadioGroup>
            </FormControl>
        </div>
    )
}
